export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/tuner-icon.svg?38ebbe6eeb2d21b95c1e636954f2e1c9";